import { render, staticRenderFns } from "./transferReservationDetailModal.vue?vue&type=template&id=4d0b78ec&scoped=true&"
import script from "./transferReservationDetailModal.vue?vue&type=script&lang=ts&"
export * from "./transferReservationDetailModal.vue?vue&type=script&lang=ts&"
import style0 from "./transferReservationDetailModal.vue?vue&type=style&index=0&id=4d0b78ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0b78ec",
  null
  
)

export default component.exports